import { ref } from 'vue'
import type { dikeProfilesElevationType } from '@/store/type/dikeProfiles.type'

export const dikeProfilePlotlyMixin = () => {
  const baseLine = ref({
    width: 1,
    dash: 'dot'
  })

  const format = ref({
    x: [],
    y: [],
    mode: 'lines+text',
    type: 'scatter',
    name: null,
    textfont: {
      family: 'Roboto'
    }
  })

  const dikeProfilePlotDataWithHighlight = (
    dikeProfiles: dikeProfilesElevationType[],
    highlightedId = null
  ) => {
    return (
      dikeProfiles?.map((dikeProfile) => {
        const dikeProfileSingle = JSON.parse(JSON.stringify(format.value))
        dikeProfileSingle.x = dikeProfile.geometry.map((geom) => geom.x)
        dikeProfileSingle.y = dikeProfile.geometry.map((geom) => geom.y)
        dikeProfileSingle.name = dikeProfile.properties.name
        dikeProfileSingle.id = dikeProfile.id
        dikeProfileSingle.hovertemplate = dikeProfile.properties.name
        const isHighlighted = dikeProfile.id === highlightedId
        const dashObject = isHighlighted ? {} : { dash: baseLine.value.dash }
        dikeProfileSingle.line = {
          ...dashObject,
          color: dikeProfile.properties.color,
          width: isHighlighted ? 3 : baseLine.value.width
        }
        return dikeProfileSingle
      }) || []
    )
  }

  return {
    baseLine,
    format,
    dikeProfilePlotDataWithHighlight
  }
}
